module.exports = __webpack_public_path__ + "media/images/emblems/Ringgenberg-coat_of_arms-13716292528aded1313842a6e8000751.svg";